import { useEffect } from "react";

function PrivacyRedirect() {
  useEffect(() => {
    window.location.href =
      "https://docs.google.com/spreadsheets/d/1Ox1LULqUPNHwFj1hwhxmr0Z-sqKyRbFSeL9NTuQkBeE/edit?usp=sharing";
  }, []);

  return <p>Redirecting to Privacy Policy...</p>;
}

export default PrivacyRedirect;
